import { Component, OnInit } from '@angular/core';
import {
  Router,
  NavigationExtras,
  ActivatedRoute,
  Params,
} from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  preselectedClinic: string;
  superClinicId: string;
  service: string;
  type: string;
  singleClinic: string;
  navigationClass: string;

  constructor(private route: ActivatedRoute, private router: Router) {
    router.events.subscribe((val) => {
      // Add margin to footer, if nex/back navigation visible
      const path_name = window.location.pathname;

      if (
        path_name === '/body-parts' ||
        path_name === '/offer-fysiq' ||
        path_name === '/expert' ||
        path_name === '/service' ||
        path_name === '/booking-visit'
      ) {
        this.navigationClass = 'with-margin';
      } else {
        this.navigationClass = 'without-margin';
      }
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.preselectedClinic = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.type = params.type;
      this.singleClinic = params.singleClinic;
    });
  }

  goToPolicy() {
    const params = {
      type: this.type,
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.preselectedClinic) {
      params['clinics'] = this.preselectedClinic;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate(['/privacy-policy'], navigationExtras);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts